window.$ = require("jquery");

// https://flatpickr.js.org/
const flatpickr = require("flatpickr");

//https://sweetalert2.github.io/
import Swal from "sweetalert2";

//https://github.com/js-cookie/js-cookie
import Cookies from "js-cookie";

//https://robinherbots.github.io/Inputmask/#/documentation
import Inputmask from "inputmask";

//https://select2.org/
window.select2 = require("select2");
require("select2/dist/js/i18n/az");
$.fn.select2.defaults.set("theme", "bootstrap-5");
$.fn.select2.defaults.set("language", "az");
$.fn.select2.defaults.set("placeholder", {
  id: "",
  text: "Birini seçin",
});
$.fn.select2.defaults.set("allowClear", true);

import { Fancybox } from "@fancyapps/ui";

//https://www.fancyapps.com/fancybox/getting-started/
export { Cookies, Swal, Inputmask, flatpickr, Fancybox };
